import { getSettings, updateSettings } from '@/apis/settings'
import { getEmergencies } from '@/apis/emergency'
import { EMERGENCY_PENDING } from '@/utils/config'

const state = {
    latitude: 0,
    longitude: 0,
    timezone: null,
    country: 'us',
    settings: {},

    menuVisible: true,
    hasEmergency: false
}

const mutations = {
    SET_LATITUDE: (state, latitude) => {
        state.latitude = latitude
    },
    SET_LONGITUDE: (state, longitude) => {
        state.longitude = longitude
    },
    SET_TIMEZONE_HOURS: (state, timezone) => {
        state.timezone = timezone
    },
    SET_COUNTRY: (state, country) => {
        state.country = country
    },
    SET_SETTINGS: (state, settings) => {
        state.settings = settings
    },
    PATCH_SETTINGS: (state, settings) => {
        state.settings = Object.assign({}, state.settings, settings)
    },

    SET_MENU_VISIBLE: (state, menuVisible) => {
        state.menuVisible = menuVisible
    },

    SET_HAS_EMERGENCY: (state, hasEmergency) => {
        state.hasEmergency = hasEmergency
    },
}

const actions = {
    getSettings({ commit }) {
        return new Promise((resolve, reject) => {
            getSettings().then(response => {
                const { data } = response
                const { latitude, longitude, timezone_offset_seconds, country } = data

                commit('SET_SETTINGS', data)
                commit('SET_LATITUDE', parseFloat(latitude))
                commit('SET_LONGITUDE', parseFloat(longitude))
                commit('SET_COUNTRY', country)
                commit('SET_TIMEZONE_HOURS', timezone_offset_seconds ? timezone_offset_seconds/3600 : 0)

                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updateSettings({ commit }, settings) {
        return new Promise((resolve, reject) => {
            updateSettings(settings).then(response => {
                
                commit('PATCH_SETTINGS', settings)

                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    checkEmergency({ commit }) {
        return new Promise((resolve, reject) => {
            getEmergencies({
                size: 1,
                page: 1,
                q: {
                    resolved: EMERGENCY_PENDING
                }
            }).then(response => {
                const { data } = response
                commit('SET_HAS_EMERGENCY', data.length >= 1 ? true : false)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}